// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"MainLayout_mainSection__Bg-U6"};